function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import __ from 'ramda/src/__';
import { MetadataCodeLoadedSelector, MetadataCodeTypeDictionarySelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import customerCareKeys from '../../../../locales/keys';
import { UNIT_OF_MEASURES } from '../../../../customercare.constants';
var EntitlementBalanceController = /*#__PURE__*/function () {
  function EntitlementBalanceController(uiNotificationService, $ngRedux) {
    _classCallCheck(this, EntitlementBalanceController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      customerCareKeys: customerCareKeys,
      emptyCellEmDash: '—',
      isCurrencyBalanceUnitCode: false,
      isUnitBalanceUnitCode: false,
      showUnit: true,
      uiNotificationService: uiNotificationService,
      unitOfMeasure: undefined,
      UNIT_OF_MEASURES: UNIT_OF_MEASURES
    });
  }
  return _createClass(EntitlementBalanceController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var codeTables = [CODES.UnitsOfMeasure];
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          unitOfMeasures: MetadataCodeTypeDictionarySelector(CODES.UnitsOfMeasure, store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      Promise.all(codeTables.map(function (codeType) {
        if (!_this.state.codeTypeLoaded(codeType)) {
          return _this.actions.fetchCodeTypes(codeType);
        }
      })).then(function () {
        _this.getUnitOfMeasure();
      }).catch(function (error) {
        _this.uiNotificationService.transientError(error.translatedMessage);
      });
      this.isCurrencyBalanceUnitCode = "".concat(this.balanceUnitCode) === this.UNIT_OF_MEASURES.CURRENCY;
      this.isUnitBalanceUnitCode = "".concat(this.balanceUnitCode) === this.UNIT_OF_MEASURES.UNITS;
    }
  }, {
    key: "$onChanges",
    value: function $onChanges() {
      this.getUnitOfMeasure();
    }
  }, {
    key: "getUnitOfMeasure",
    value: function getUnitOfMeasure() {
      if (this.unitDisplayName) {
        this.unitOfMeasure = this.unitDisplayName;
      } else {
        var unitCode = this.state && this.state.unitOfMeasures[this.balanceUnitCode];
        this.unitOfMeasure = unitCode && (this.shortUnitName && unitCode.AdditionalProperties.short_name || unitCode.Name);
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {
    balance: '<',
    balanceUnitCode: '<',
    currencyCode: '<?',
    isUnlimited: '<?',
    showUnit: '<?',
    shortUnitName: '<?',
    toFixedValue: '<?',
    unitDisplayName: '<?'
  },
  controller: EntitlementBalanceController,
  template: require('./entitlement.balance.template.html')
};